<template>
  <div class="space-y-3">
    <div class="flex items-center gap-3">
      <div class="flex rounded border border-gray-200 overflow-hidden bg-white">
        <button
          v-for="v in VIEWS"
          :key="v.id"
          class="px-3 py-1 text-xs"
          :class="view === v.id ? 'bg-gray-800 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'"
          @click="view = v.id"
        >
          {{ v.label }}
        </button>
      </div>
    </div>

    <DatasetCatalog
      v-if="view === 'datasets'"
      :datasets="datasets"
      :attributes="attributes"
      :loading="loading"
      @refresh="fetchCatalog"
      @attribute-saved="fetchCatalog"
    />
    <SavedFrameCatalog v-else-if="view === 'frames'" />
    <Overview_ETL_Data_Attributes v-else />
  </div>
</template>

<script>
import axios from 'axios';
import DatasetCatalog from './DatasetCatalog.vue';
import SavedFrameCatalog from './SavedFrameCatalog.vue';
import Overview_ETL_Data_Attributes from './Overview_ETL_Data_Attributes.vue';

export default {
  name: 'OverviewETLDatasets',
  components: { DatasetCatalog, SavedFrameCatalog, Overview_ETL_Data_Attributes },
  data() {
    return {
      VIEWS: [
        { id: 'datasets', label: 'Datasets' },
        { id: 'attributes', label: 'Data Attributes' },
        { id: 'frames', label: 'Saved Frames' },
      ],
      view: 'datasets',
      attributes: [],
      datasets: [],
      loading: false,
    };
  },
  mounted() {
    this.fetchCatalog();
  },
  methods: {
    async fetchCatalog() {
      this.loading = true;
      try {
        const [attributes, datasets] = await Promise.all([
          axios.get('api/impact_analytics/attributes/'),
          axios.get('api/impact_analytics/datasets/'),
        ]);
        this.attributes = attributes.data;
        this.datasets = datasets.data;
      } catch {
        this.attributes = [];
        this.datasets = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
